import React from 'react';
import { Grid, Typography } from '@mui/material';
import BackButton from 'components/Button';

const styles = {
    root: {
        p: 3,
        width: '60%',
    },
    section: {
        mb: 4,
    },
    title: {
        mb: 2,
        fontWeight: 'bold',
    },
    content: {
        mb: 2,
    },
    backButton: {
        mt: 2,
        justifyContent: 'center',
        display: 'flex',
    },
};

const ServicoAbordagemSocial = () => {

    return (
        <Grid container style={{ justifyContent: 'center' }}>
            <Grid sx={styles.root}>
                <Grid item xs={12} sx={styles.section}>
                    <Typography variant="h4" sx={styles.title}>
                        Combate às Drogas: Serviço de Abordagem Social Multidisciplinar
                    </Typography>
                    <Typography variant="body1" sx={styles.content}>
                        <strong>Data:</strong> Segunda, 12 de maio de 2014
                    </Typography>
                    <Typography variant="body1" sx={styles.content}>
                        <strong>Município:</strong> Rondonópolis, Município de Rondonópolis/MT
                    </Typography>
                </Grid>
                <Grid item xs={12} sx={styles.section}>
                    <Typography variant="h5" sx={styles.title}>
                        Identificação do Município
                    </Typography>
                    <Typography variant="body1" sx={styles.content}>
                        A pouco mais de 200 quilômetros da capital Cuiabá, Rondonópolis tem uma população estimada em 208.019 habitantes. O agronegócio deixou de ser a principal fonte de economia e, hoje, os ideais são voltados para a indústria. O objetivo é agregar valor a produtos como a soja e o algodão. Por isso, a cidade já é considerada a mais industrializada do Estado.
                        A localização privilegiada no entroncamento das rodovias BR-163 e BR-364 coloca Rondonópolis entre os principais pontos de ligação entre a região Norte e a região Sul.
                    </Typography>
                </Grid>
                <Grid item xs={12} sx={styles.section}>
                    <Typography variant="h5" sx={styles.title}>
                        Ação
                    </Typography>
                    <Typography variant="body1" sx={styles.content}>
                        A partir da verificação de cenas de uso de drogas e do aumento do número de indivíduos em situação de rua, o Município decidiu realizar o serviço de abordagem social por meio de busca ativa na comunidade. O intuito era levar para essas pessoas a oportunidade de mudar de vida, oferecendo todo o apoio necessário para que pudessem ser reintegradas na sociedade.
                        Para isso, foi criada uma equipe multidisciplinar, composta por duas assistentes sociais, uma psicóloga, um motorista e dois policiais militares. As abordagens se davam em locais públicos do Município, considerando a circulação de pessoas e a existência de comércio, como terminais de ônibus, praças e entroncamento de estradas. E ocorriam três dias por semana, geralmente no período da noite.
                        A iniciativa, que foi realizada pela primeira vez ao final de 2013, é uma parceria entre o Centro de Referência Especializado de Assistência Social (Creas) da Secretaria de Promoção e Assistência Social e a Polícia Militar.
                    </Typography>
                </Grid>
                <Grid item xs={12} sx={styles.section}>
                    <Typography variant="h5" sx={styles.title}>
                        Resultados
                    </Typography>
                    <Typography variant="body1" sx={styles.content}>
                        - O projeto realizou abordagem social com mais de 300 pessoas em situação de rua.
                        - A iniciativa serviu de base para um primeiro levantamento sobre a quantidade de usuários de drogas na região.
                        - Foi promovida a inclusão dos indivíduos na rede de saúde e assistência social.
                        - A ação foi bem recebida e aceita pelo público-alvo.
                        - Houve a participação da sociedade civil para colaborar com a reinserção social daqueles que já haviam concluído o tratamento.
                        - A Secretaria de Promoção e Assistência Social agora trabalha para ampliar o projeto.
                    </Typography>
                </Grid>
                <Grid item xs={12} sx={styles.section}>
                    <Typography variant="h5" sx={styles.title}>
                        Recursos
                    </Typography>
                    <Typography variant="body1" sx={styles.content}>
                        O serviço é financiado pelo governo federal, por meio do Ministério do Desenvolvimento Social e Combate à Fome (MDS), e a contrapartida é do governo municipal. O valor do investimento por parte do Município é de aproximadamente R$ 13.000,00 (mensal).
                    </Typography>
                </Grid>
                <Grid item xs={12} sx={styles.backButton}>
                   <BackButton />
                </Grid>
            </Grid>
        </Grid>
    );
};

export default ServicoAbordagemSocial;
